import * as Actions from "../redux/patientSession";
import * as AdminSessionActions from "../redux/adminSession";
import * as OmniDataAPI from "../../data/omniDataAPI";
import * as OmniDemoData from "../../data/omniDemoData";
import * as PartnerSessionActions from "../redux/partnerSession";
import * as ProviderSessionActions from "../redux/providerSession";

import { call, put, select, takeLatest } from "redux-saga/effects";
import { deepCopyObject, isValidUUID } from "../../utils/helpers";
import { helperGetIsoDate, loadJSONDataFromURL } from "../../utils/helpers";

import constants from "../../assets/constants";
import { getChart } from "../../assets/patientChart";
import { v4 as uuid } from "uuid";

export function* loadPatientODM({ payload }) {
  try {
    //clear out the existing information
    yield put(Actions.setPatientODMRequest(null));
    if (isValidUUID(payload)) {
      //payload is a valid UUID
      let patientODM = yield call(OmniDataAPI.getPatient, payload);
      if (patientODM == null) {
        yield put(Actions.patientSessionRequestFailed("OmniDataAPI.getPatient FAILED"));
      } else {
        yield put(Actions.setPatientODMRequest(patientODM));
        yield put(Actions.loadPatientODMSuccess());
      }
    } else {
      //TODO depricate
      //This is the case where we are using a demo Patient
      console.log("attempting to set a demo patient");
      let patientODM = OmniDemoData.getDemoPatientODM(payload);
      patientODM._id = payload;

      yield put(Actions.setPatientODMRequest(patientODM));
      yield put(Actions.loadPatientODMSuccess());
    }
  } catch (error) {
    yield put(Actions.patientSessionRequestFailed(error));
  }
}

export function* setPatientODM({ payload }) {
  try {
    //Validate Object
    //Do all ancillary data loads here
    yield put(Actions.loadPatientAssessmentsRequest(payload._id));
    yield put(Actions.loadPatientMotivationsRequest(payload._id));

    //#region REFACTOR and DELETE
    yield put(Actions.loadPatientChartRequest(payload));
    yield put(Actions.loadPatientNotesRequest(payload));
    yield put(Actions.loadPatientImageRequest(payload));
    yield put(Actions.loadPatientComplianceRequest(payload));
    yield put(Actions.loadPatientQuestionsRequest(payload));
    yield put(Actions.loadPatientHistoryRequest(payload));
    yield put(Actions.loadPatientJournalRequest(payload));
    yield put(Actions.loadPatientTreatmentPlanRequest(payload));
    //#endregion

    yield put(Actions.setPatientODMSuccess(payload));
  } catch (error) {
    yield put(Actions.patientSessionRequestFailed(error));
  }
}

export function* updatePatient({ payload }) {
  try {
    if (payload._id == null) {
      //CREATE
      payload._id = uuid();
      let newPatient = yield call(OmniDataAPI.createPatient, payload);
      if (newPatient == null) {
        yield put(Actions.patientSessionRequestFailed("OmniDataAPI.createPatient FAILED"));
      } else {
        yield put(Actions.setPatientODMRequest(newPatient));
        yield put(Actions.updatePatientSuccess());
        yield put(AdminSessionActions.reflectUpdatedPatientODMRequest(newPatient));
        yield put(PartnerSessionActions.reflectUpdatedPatientODMRequest(newPatient));
        yield put(ProviderSessionActions.reflectUpdatedPatientODMRequest(newPatient));
      }
    } else if (isValidUUID(payload._id)) {
      //UPDATE
      let newPatient = yield call(OmniDataAPI.updatePatient, payload);
      if (newPatient == null) {
        yield put(Actions.patientSessionRequestFailed("OmniDataAPI.updatePatient FAILED"));
      } else {
        yield put(Actions.setPatientODMRequest(newPatient));
        yield put(Actions.updatePatientSuccess());
        yield put(AdminSessionActions.reflectUpdatedPatientODMRequest(newPatient));
        yield put(PartnerSessionActions.reflectUpdatedPatientODMRequest(newPatient));
        yield put(ProviderSessionActions.reflectUpdatedPatientODMRequest(newPatient));
      }
    } else {
      yield put(Actions.patientSessionRequestFailed("updatePatient: bad payload"));
    }
  } catch (error) {
    yield put(Actions.patientSessionRequestFailed(error));
  }
}

export function* deletePatient({ payload }) {
  try {
    //payload is UUID
    if (isValidUUID(payload)) {
      const patient = yield select(Actions.patientODMSelector);
      let deletedPatient = yield call(OmniDataAPI.deletePatient, payload);
      if (deletedPatient == null) {
        yield put(Actions.deletePatientSuccess(patient));
        //this method assumes that an ID alone is a delete
        yield put(AdminSessionActions.reflectUpdatedPatientODMRequest(patient));
      }
    }
    const patientODM = yield select(Actions.patientODMSelector);
    if (patientODM != null && payload === patientODM._id) {
      yield put(Actions.setPatientODMRequest(null));
    } else {
      yield put(Actions.patientSessionRequestFailed("deletePatient: invalid UUID()"));
    }
  } catch (error) {
    yield put(Actions.patientSessionRequestFailed(error));
  }
}

export function* loadPatientAssessments({ payload }) {
  try {
    //payload is _id

    if (isValidUUID(payload)) {
      //payload is a valid UUID
      // let assessments = yield call(OmniDataAPI.getAllAssessments, payload);

      //TODO create a method to get by assigned id, or iterate through their assessments and get it ourselves

      let assessments = [];

      yield put(Actions.loadPatientAssessmentsSuccess(assessments));
    } else {
      yield put(Actions.patientSessionRequestFailed("loadPatientAssessments: Invalid UUID"));

      // Mocked this up for Greeley demo

      const newInfo = yield call(
        loadJSONDataFromURL,
        `${
          window.location.origin.includes("localhost")
            ? `https://dev.omnisciahealth.coach`
            : window.location.origin
        }/assets/demo/demoPatientAssessments.json`
      );
      yield put(Actions.loadPatientAssessmentsSuccess(newInfo));
    }
  } catch (error) {
    yield put(Actions.patientSessionRequestFailed(error));
  }
}

export function* loadAssessmentODM({ payload }) {
  try {
    //payload is patientODM

    if (isValidUUID(payload)) {
      //payload is a valid UUID
      let assessment = yield call(OmniDataAPI.getAssessment, payload);

      yield put(Actions.loadAssessmentODMSuccess(assessment));
    } else {
      yield put(Actions.patientSessionRequestFailed("loadAssessmentODM: Invalid UUID"));
    }
  } catch (error) {
    yield put(Actions.patientSessionRequestFailed(error));
  }
}

export function* updateAssessment({ payload }) {
  try {
    //payload is assessmentODM

    const patientODM = yield select(Actions.patientODMSelector);

    if (patientODM != null) {
      const assessments = yield select(Actions.patientAssessmentsSelector);
      const newAssessments =
        assessments == null ? [] : assessments.filter(obj => obj._id !== payload._id);

      payload.omniRelationships.userId = patientODM._id;
      // Account for DEMO
      if (payload._id == null && isValidUUID(payload.omniRelationships.userId)) {
        //CREATE
        payload._id = uuid();
        let newAssessment = yield call(OmniDataAPI.createAssessment, payload);
        // DEMO
        // This is here becuase the API isn't finished yet
        if (newAssessment == null) {
          newAssessment = payload;
        }
        newAssessments.push(newAssessment);
      } else if (isValidUUID(payload._id) && isValidUUID(payload.omniRelationships.userId)) {
        //UPDATE
        let newAssessment = yield call(OmniDataAPI.updateAssessment, payload);
        // DEMO
        // This is here becuase the API isn't finished yet
        if (newAssessment == null) {
          newAssessment = payload;
        }
        newAssessments.push(payload);
      } else {
        //DEMO
        newAssessments.push(payload);
      }

      yield put(Actions.updateAssessmentSuccess(newAssessments));
    } else {
      yield put(Actions.patientSessionRequestFailed("Current Patient is NULL"));
    }
  } catch (error) {
    yield put(Actions.patientSessionRequestFailed(error));
  }
}

//#region Motivations
export function* loadPatientMotivations({ payload }) {
  try {
    //payload is _id

    if (isValidUUID(payload)) {
      //payload is a valid UUID
      let motivations = yield call(OmniDataAPI.getAllMotivations, payload);

      yield put(Actions.loadPatientMotivationsSuccess(motivations));
    } else {
      yield put(Actions.patientSessionRequestFailed("loadPatientMotivations: Invalid UUID"));

      const newInfo = yield call(
        loadJSONDataFromURL,
        `${
          window.location.origin.includes("localhost")
            ? `https://dev.omnisciahealth.coach`
            : window.location.origin
        }/assets/demo/demoPatientMotivations.json`
      );
      let theReturn = newInfo[payload];
      yield put(Actions.loadPatientMotivationsSuccess(theReturn));
    }
  } catch (error) {
    yield put(Actions.patientSessionRequestFailed(error));
  }
}

export function* loadMotivationODM({ payload }) {
  try {
    //payload is patientODM

    if (isValidUUID(payload)) {
      //payload is a valid UUID
      let motivation = yield call(OmniDataAPI.getMotivation, payload);

      yield put(Actions.loadMotivationODMSuccess(motivation));
    } else {
      yield put(Actions.patientSessionRequestFailed("loadMotivationODM: Invalid UUID"));
    }
  } catch (error) {
    yield put(Actions.patientSessionRequestFailed(error));
  }
}

export function* updateMotivation({ payload }) {
  try {
    //payload is motivationODM
    const patientODM = yield select(Actions.patientODMSelector);
    const motivations = yield select(Actions.patientMotivationsSelector);
    const newMotivations =
      motivations == null ? [] : motivations.filter(obj => obj._id !== payload._id);

    if (patientODM != null) {
      payload.omniRelationships.userId = patientODM._id;
      if (payload._id == null) {
        //CREATE
        payload._id = uuid();
        let newMotivation = yield call(OmniDataAPI.createMotivation, payload);
        newMotivations.push(newMotivation);
      } else if (isValidUUID(payload._id)) {
        //UPDATE
        let newMotivation = yield call(OmniDataAPI.updateMotivation, payload);
        if (newMotivation == null) {
          newMotivation = payload;
        }
        newMotivations.push(payload);
      } else {
        //DEMO
        newMotivations.push(payload);
      }

      yield put(Actions.updateMotivationSuccess(newMotivations));
    } else {
      yield put(Actions.patientSessionRequestFailed("Current Patient is NULL"));
    }
  } catch (error) {
    yield put(Actions.patientSessionRequestFailed(error));
  }
}

export function* deleteMotivation({ payload }) {
  try {
    //payload is UUID

    if (isValidUUID(payload)) {
      const motivations = yield select(Actions.patientMotivationsSelector);
      const newMotivations =
        motivations == null ? [] : motivations.filter(obj => obj._id !== payload);
      let motivation = yield call(OmniDataAPI.deleteMotivation, payload);
      if (motivation != null) {
        yield put(Actions.deleteMotivationSuccess(newMotivations));
      } else {
        yield put(Actions.patientSessionRequestFailed("deleteMotivation: call failed"));
      }
    } else {
      yield put(Actions.patientSessionRequestFailed("deleteMotivation: invalid UUID()"));
    }
  } catch (error) {
    yield put(Actions.patientSessionRequestFailed(error));
  }
}

//#endregion

//#region REFACTOR and DELETE

export function* loadPatientChart({ payload }) {
  try {
    let patientChart = getChart(payload._id);

    yield put(Actions.loadPatientChartSuccess(patientChart));
  } catch (error) {
    yield put(Actions.patientSessionRequestFailed(error));
  }
}

export function* loadPatientImage({ payload }) {
  try {
    //TODO call DB here to get data retrieval
    let image = `${
      window.location.origin.includes("localhost")
        ? `https://dev.omnisciahealth.coach`
        : window.location.origin
    }/assets/demo/images/userImage(31).jpg`;

    if (payload === constants.demoUserId.userTwo) {
      image = `${
        window.location.origin.includes("localhost")
          ? `https://dev.omnisciahealth.coach`
          : window.location.origin
      }/assets/demo/images/userImage(25).jpg`;
    }
    if (payload === constants.demoUserId.userThree) {
      image = `${
        window.location.origin.includes("localhost")
          ? `https://dev.omnisciahealth.coach`
          : window.location.origin
      }/assets/demo/images/userImage(29).jpg`;
    }
    if (payload === constants.demoUserId.userFour) {
      image = `${
        window.location.origin.includes("localhost")
          ? `https://dev.omnisciahealth.coach`
          : window.location.origin
      }/assets/demo/images/userImage(42).jpg`;
    }

    yield put(Actions.loadPatientImageSuccess(image));
  } catch (error) {
    yield put(Actions.patientSessionRequestFailed(error));
  }
}

export function* loadPatientNotes({ payload }) {
  try {
    const newInfo = yield call(
      loadJSONDataFromURL,
      `${
        window.location.origin.includes("localhost")
          ? `https://dev.omnisciahealth.coach`
          : window.location.origin
      }/assets/demo/demoPatientNotes.json`
    );
    let theReturn = newInfo[payload._id];
    yield put(Actions.loadPatientNotesSuccess(theReturn));
  } catch (error) {
    yield put(Actions.patientSessionRequestFailed(error));
  }
}

export function* loadPatientCompliance({ payload }) {
  try {
    //TODO call DB here to get data retrieval
    let patientCompliance = "95";

    if (payload === constants.demoUserId.userTwo) {
      patientCompliance = "92";
    }
    if (payload === constants.demoUserId.userThree) {
      patientCompliance = "60";
    }
    if (payload === constants.demoUserId.userFour) {
      patientCompliance = "100";
    }

    yield put(Actions.loadPatientComplianceSuccess(patientCompliance));
  } catch (error) {
    yield put(Actions.patientSessionRequestFailed(error));
  }
}

export function* updatePatientNote({ payload }) {
  try {
    const originalNotes = yield select(Actions.patientNotesSelector);
    const patientNotes = originalNotes.filter(obj => obj.id !== payload.id);

    if (payload.id == null) {
      payload.id = uuid();
    }
    //TODO replace with API call

    const newPatientNotes = deepCopyObject(patientNotes);
    newPatientNotes.unshift(payload);

    yield put(Actions.updatePatientNoteSuccess(newPatientNotes));
  } catch (error) {
    yield put(Actions.patientSessionRequestFailed(error));
  }
}

export function* deletePatientNote({ payload }) {
  try {
    const originalNotes = yield select(Actions.patientNotesSelector);
    const patientNotes = originalNotes.filter(obj => obj.id !== payload.id);
    //TODO replace with API call
    yield put(Actions.deletePatientNoteSuccess(patientNotes));
  } catch (error) {
    yield put(Actions.patientSessionRequestFailed(error));
  }
}

export function* loadPatientQuestions({ payload }) {
  try {
    //TODO replace with API call
    const newInfo = yield call(
      loadJSONDataFromURL,
      `${
        window.location.origin.includes("localhost")
          ? `https://dev.omnisciahealth.coach`
          : window.location.origin
      }/assets/demo/demoPatientQuestions.json`
    );
    let theReturn = newInfo[payload._id];

    yield put(Actions.loadPatientQuestionsSuccess(theReturn));
  } catch (error) {
    yield put(Actions.patientSessionRequestFailed(error));
  }
}

export function* updatePatientQuestion({ payload }) {
  try {
    const originalQuestions = yield select(Actions.patientQuestionsSelector);
    const patientQuestions = originalQuestions.filter(obj => obj.id !== payload.id);

    if (payload.id == null) {
      payload.id = uuid();
    }

    //TODO replace with API call
    const newPatientQuestions = deepCopyObject(patientQuestions);
    newPatientQuestions.unshift(payload);

    yield put(Actions.updatePatientQuestionSuccess(newPatientQuestions));
  } catch (error) {
    yield put(Actions.patientSessionRequestFailed(error));
  }
}

export function* deletePatientQuestion({ payload }) {
  try {
    const originalQuestions = yield select(Actions.patientQuestionsSelector);
    const patientQuestions = originalQuestions.filter(obj => obj.id !== payload.id);
    //TODO replace with API call
    yield put(Actions.deletePatientQuestionSuccess(patientQuestions));
  } catch (error) {
    yield put(Actions.patientSessionRequestFailed(error));
  }
}

export function* updatePatientConditions({ payload }) {
  try {
    let patientChart = yield select(Actions.patientChartSelector);
    patientChart = deepCopyObject(patientChart);
    patientChart.conditions = payload;

    yield put(Actions.updatePatientConditionsSuccess(patientChart));
  } catch (error) {
    yield put(Actions.patientSessionRequestFailed(error));
  }
}

export function* updatePatientMedications({ payload }) {
  try {
    let patientChart = yield select(Actions.patientChartSelector);
    patientChart = deepCopyObject(patientChart);
    patientChart.medications = payload;

    yield put(Actions.updatePatientMedicationsSuccess(patientChart));
  } catch (error) {
    yield put(Actions.patientSessionRequestFailed(error));
  }
}

export function* updatePatientGoals({ payload }) {
  try {
    let patientChart = yield select(Actions.patientChartSelector);
    patientChart = deepCopyObject(patientChart);
    patientChart.goals = payload;

    yield put(Actions.updatePatientGoalsSuccess(patientChart));
  } catch (error) {
    yield put(Actions.patientSessionRequestFailed(error));
  }
}

export function* updatePatientSymptoms({ payload }) {
  try {
    let patientChart = yield select(Actions.patientChartSelector);
    patientChart = deepCopyObject(patientChart);
    patientChart.symptoms = payload;

    yield put(Actions.updatePatientSymptomsSuccess(patientChart));
  } catch (error) {
    yield put(Actions.patientSessionRequestFailed(error));
  }
}

export function* loadPatientJournal({ payload }) {
  try {
    const newInfo = yield call(
      loadJSONDataFromURL,
      `${
        window.location.origin.includes("localhost")
          ? `https://dev.omnisciahealth.coach`
          : window.location.origin
      }/assets/demo/demoPatientJournals.json`
    );
    let theReturn = newInfo[payload._id];
    for (let index = 0; index < theReturn.length; ++index) {
      theReturn[index].date = helperGetIsoDate((theReturn.length - index) * 7);
    }

    yield put(Actions.loadPatientJournalSuccess(theReturn));
  } catch (error) {
    yield put(Actions.patientSessionRequestFailed(error));
  }
}

export function* updatePatientJournalEntry({ payload }) {
  try {
    let patientJournal = yield select(Actions.patientJournalSelector);
    const newJournal = patientJournal.filter(obj => obj.id !== payload.id);

    newJournal.push(payload);

    yield put(Actions.updatePatientJournalEntrySuccess(newJournal));
  } catch (error) {
    yield put(Actions.patientSessionRequestFailed(error));
  }
}

export function* deletePatientJournalEntry({ payload }) {
  try {
    let patientJournal = yield select(Actions.patientJournalSelector);
    const newJournal = patientJournal.filter(obj => obj.id !== payload.id);
    yield put(Actions.deletePatientJournalEntrySuccess(newJournal));
  } catch (error) {
    yield put(Actions.patientSessionRequestFailed(error));
  }
}

export function* loadPatientHistory({ payload }) {
  try {
    const newInfo = yield call(
      loadJSONDataFromURL,
      `${
        window.location.origin.includes("localhost")
          ? `https://dev.omnisciahealth.coach`
          : window.location.origin
      }/assets/demo/demoPaitientHistory.json`
    );
    let theReturn = newInfo[payload._id];
    yield put(Actions.loadPatientHistorySuccess(theReturn));
  } catch (error) {
    yield put(Actions.patientSessionRequestFailed(error));
  }
}

export function* updatePatientHistory({ payload }) {
  try {
    const originalHistory = yield select(Actions.patientHistorySelector);
    const patientHistory = originalHistory.filter(obj => obj.id !== payload.id);

    if (payload.id == null) {
      payload.id = uuid();
    }

    //TODO replace with API call
    const newPatientHistory = deepCopyObject(patientHistory);
    newPatientHistory.unshift(payload);

    yield put(Actions.updatePatientHistorySuccess(newPatientHistory));
  } catch (error) {
    yield put(Actions.patientSessionRequestFailed(error));
  }
}

export function* deletePatientHistory({ payload }) {
  try {
    const originalHistory = yield select(Actions.patientHistorySelector);
    const patientHistory = originalHistory.filter(obj => obj.id !== payload.id);
    //TODO replace with API call
    yield put(Actions.deletePatientHistorySuccess(patientHistory));
  } catch (error) {
    yield put(Actions.patientSessionRequestFailed(error));
  }
}

export function* loadPatientTreatmentPlan({ payload }) {
  try {
    //TODO replace with API call
    yield put(Actions.loadPatientTreatmentPlanSuccess(null));
  } catch (error) {
    yield put(Actions.patientSessionRequestFailed(error));
  }
}

export function* updatePatientTreatmentPlan({ payload }) {
  try {
    if (payload.id == null) {
      payload.treatmentPlanId = uuid();
    }

    const newPatientTreatmentPlan = deepCopyObject(payload);

    yield put(Actions.updatePatientTreatmentPlanSuccess(newPatientTreatmentPlan));
  } catch (error) {
    yield put(Actions.patientSessionRequestFailed(error));
  }
}

export function* deletePatientTreatmentPlan({ payload }) {
  try {
    const originalTreatmentPlan = yield select(Actions.patientTreatmentPlanSelector);
    const patientTreatmentPlan = originalTreatmentPlan.filter(obj => obj.id !== payload.id);
    //TODO replace with API call
    yield put(Actions.deletePatientTreatmentPlanSuccess(patientTreatmentPlan));
  } catch (error) {
    yield put(Actions.patientSessionRequestFailed(error));
  }
}
//#endregion

//  saga
export default function* patientDataSaga() {
  yield takeLatest(Actions.loadPatientODMRequest, loadPatientODM);
  yield takeLatest(Actions.setPatientODMRequest, setPatientODM);
  yield takeLatest(Actions.updatePatientRequest, updatePatient);
  yield takeLatest(Actions.deletePatientRequest, deletePatient);

  yield takeLatest(Actions.loadPatientAssessmentsRequest, loadPatientAssessments);
  yield takeLatest(Actions.loadAssessmentODMRequest, loadAssessmentODM);
  yield takeLatest(Actions.updateAssessmentRequest, updateAssessment);

  yield takeLatest(Actions.loadPatientMotivationsRequest, loadPatientMotivations);
  yield takeLatest(Actions.loadMotivationODMRequest, loadMotivationODM);
  yield takeLatest(Actions.updateMotivationRequest, updateMotivation);
  yield takeLatest(Actions.deleteMotivationRequest, deleteMotivation);

  //#region REFACTOR and DELETE

  yield takeLatest(Actions.loadPatientChartRequest, loadPatientChart);
  yield takeLatest(Actions.loadPatientImageRequest, loadPatientImage);
  yield takeLatest(Actions.loadPatientComplianceRequest, loadPatientCompliance);

  yield takeLatest(Actions.loadPatientNotesRequest, loadPatientNotes);
  yield takeLatest(Actions.updatePatientNoteRequest, updatePatientNote);
  yield takeLatest(Actions.deletePatientNoteRequest, deletePatientNote);

  yield takeLatest(Actions.loadPatientQuestionsRequest, loadPatientQuestions);
  yield takeLatest(Actions.updatePatientQuestionRequest, updatePatientQuestion);
  yield takeLatest(Actions.deletePatientQuestionRequest, deletePatientQuestion);

  yield takeLatest(Actions.loadPatientJournalRequest, loadPatientJournal);
  yield takeLatest(Actions.updatePatientJournalEntryRequest, updatePatientJournalEntry);
  yield takeLatest(Actions.deletePatientJournalEntryRequest, deletePatientJournalEntry);

  yield takeLatest(Actions.updatePatientGoalsRequest, updatePatientGoals);
  yield takeLatest(Actions.updatePatientSymptomsRequest, updatePatientSymptoms);
  yield takeLatest(Actions.updatePatientMedicationsRequest, updatePatientMedications);
  yield takeLatest(Actions.updatePatientConditionsRequest, updatePatientConditions);

  yield takeLatest(Actions.loadPatientHistoryRequest, loadPatientHistory);
  yield takeLatest(Actions.updatePatientHistoryRequest, updatePatientHistory);
  yield takeLatest(Actions.deletePatientHistoryRequest, deletePatientHistory);

  yield takeLatest(Actions.loadPatientTreatmentPlanRequest, loadPatientTreatmentPlan);
  yield takeLatest(Actions.updatePatientTreatmentPlanRequest, updatePatientTreatmentPlan);
  yield takeLatest(Actions.deletePatientTreatmentPlanRequest, deletePatientTreatmentPlan);
  //#endregion
}
